import { useCallback, useState } from 'react';
import { DayState } from '~/hooks/calendar/useDayStateForDate';
import Modal from '~/components/General/Modal';
import buttonStyles from '~/styles/button.module.css';
import cnh from '~/helpers/cnh';
import useTranslation from '~/hooks/useTranslation';
import ContactForm from './ContactForm';

type Props = {
  selectedDayState?: DayState;
  pax: number;
  packageId: number;
};

export default function ContactButton({
  selectedDayState,
  pax,
  packageId,
}: Props) {
  const translate = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const onModalClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  const onModalOpen = useCallback(() => {
    setModalOpen(true);
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={onModalOpen}
        className={cnh(buttonStyles.btn, buttonStyles.btnPrimary, buttonStyles.btnFull)}
        data-testid="contact-button"
      >
        {translate('calendar.contact_button')}
      </button>

      <Modal
        title={translate('calendar.contact_modal_title')}
        description={translate('calendar.contact_modal_description')}
        isOpen={modalOpen}
        onClose={onModalClose}
      >
        <ContactForm
          selectedDay={selectedDayState?.date}
          pax={pax}
          packageId={packageId}
        />
      </Modal>
    </>
  );
}
